import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const NOTIFICATION_DURATION = 4000;
const NotificationContext = createContext();

export function useNotification() {
    return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
    const [notification, setNotification] = useState(null);

    // ⭐ Correction : On utilise useCallback pour stabiliser la fonction notify
    // Cela empêche les useEffect des autres composants de se déclencher inutilement
    const notify = useCallback((message, type = 'success') => {
        setNotification({ message, type });
    }, []); // Dépendances vides = la fonction ne change jamais d'identité

    useEffect(() => {
        if (notification) {
            const timer = setTimeout(() => {
                setNotification(null);
            }, NOTIFICATION_DURATION);
            return () => clearTimeout(timer);
        }
    }, [notification]);

    return (
        <NotificationContext.Provider value={{ notification, notify }}>
            {children}
        </NotificationContext.Provider>
    );
}